import { lazyRemoteModule } from '@space-shell/lib/runtime'

type HandleNoSearchResultsParams = { lang: string; membership: string }

export function useNoSearchResults(params: HandleNoSearchResultsParams) {
  return async function (term: string) {
    const remoteModule = await lazyRemoteModule<
      () => {
        useNoSearchResults: (params: HandleNoSearchResultsParams) => (term: string) => void
      }
    >('community/useNoSearchResults')

    const fn = remoteModule?.()?.useNoSearchResults(params)

    if (fn) {
      fn(term)
    }
  }
}
